import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const CssMainContainer = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  background: `linear-gradient(-45deg, ${theme.palette.background.default}, ${theme.palette.background.light}, ${theme.palette.background.dark})`
}));

export default CssMainContainer;